import type { TTimestamp } from '@/types';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import { useSettingsStore } from '@/store/useSettingsStore';

dayjs.extend(utc);

export const useDateFormatter = () => {
  const settings = useSettingsStore((s) => s.settings);

  const normalizeTimestamp = (value: TTimestamp) => {
    if (value instanceof Date) return value.getTime();
    const num = Number(value);
    return num.toString().length === 10 ? num * 1000 : num;
  };

  const convertDateFormat = (format: string) => {
    // Convert lowercase format strings to dayjs uppercase format tokens
    // and replace - with / for display
    return format
      .replace(/yyyy/gi, 'YYYY')
      .replace(/mm/gi, 'MM')
      .replace(/dd/gi, 'DD')
      .replace(/-/g, '/');
  };

  const toDayjs = (value: TTimestamp) =>
    dayjs.utc(normalizeTimestamp(value)).local();

  return {
    formatDate: (v: TTimestamp) =>
      toDayjs(v)
        .locale(settings.language)
        .format(convertDateFormat(settings.dateFormat)),

    formatDateTime: (v: TTimestamp) =>
      toDayjs(v)
        .locale(settings.language)
        .format(`${convertDateFormat(settings.dateFormat)} HH:mm`),
  };
};
